import { Button, CircularProgress, Stack, TextField, Grid } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Login.css";
import { isValidEmail } from "../util";

const Login = () => {
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  const [formData, setFormData]=useState({
    email:'',
    password:''
  })
  const [loader,setLoader]=useState(false);

  // TODO: CRIO_TASK_MODULE_LOGIN - Fetch the API response
  /**
   * Perform the Login API call
   * @param {{ username: string, password: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/login"
   *
   * Example for successful response from backend:
   * HTTP 201
   * {
   *      "success": true,
   *      "token": "testtoken",
   *      "username": "criodo",
   *      "balance": 5000
   * }
   *
   * Example for failed response from backend:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Password is incorrect"
   * }
   *
   */
  const login = () => {
    if(validateInput()){
      setLoader(true);
    const url = `${config.endpoint}/auth/login`;
    axios.post(url,formData)
    .then((response) =>{
      console.info(response,"response");
      if(response.data?.status){
        enqueueSnackbar('Logged in successfully',{variant:'success'});
        setLoader(false);
        const {user,tokens}=response.data;
        localStorage.setItem('username',user?.name);
        localStorage.setItem('token',tokens?.access?.token);
        localStorage.setItem('balance',user?.walletMoney);
        history.push('/');
      }
    }).catch((err)=>{
      const {data}=err.response;
        enqueueSnackbar(data.message || 'Something went wrong. Check that the backend is running, reachable and returns valid JSON.',{variant:'error'});
      setLoader(false);
    })
    }
  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Validate the input
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false and show warning message if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that password field is not an empty value - "Password is a required field"
   */
  const validateInput = () => {
    const {email, password}=formData;
    if(!email.trim()){
      enqueueSnackbar('Email is required field',{variant:'warning'});
      return false;
    }
    if(!isValidEmail(email)){
      enqueueSnackbar('Please enter a valid email',{variant:'warning'});
      return false;
    }
    if(!password.trim().length > 0){
      enqueueSnackbar('Password is a required field',{variant:'warning'});
      return false;
    }
    return true;
  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Persist user's login information
  /**
   * Store the login information so that it can be used to identify the user in subsequent API calls
   *
   * @param {string} token
   *    API token used for authentication of requests after logging in
   * @param {string} username
   *    Username of the logged in user
   * @param {string} balance
   *    Wallet balance amount of the logged in user
   *
   * Make use of localStorage: https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage
   * -    `token` field in localStorage can be used to store the Oauth token
   * -    `username` field in localStorage can be used to store the username that the user is logged in as
   * -    `balance` field in localStorage can be used to store the balance amount in the user's wallet
   */
  const persistLogin = (token, username, balance) => {
  };
  
  const handleInputChange =(event)=>{
    setFormData({...formData,[event.target.name]:event.target.value});
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons={true} />
      <Box className="content">
        <Stack spacing={2} className="form">
        <h2 className="title">Login</h2>
        <TextField
            id="email"
            label="Email"
            variant="outlined"
            title="Email"
            name="email"
            placeholder="Enter Email"
            value={formData.email}
            onChange={(e) => handleInputChange(e)}
            fullWidth
          />
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            fullWidth
            placeholder="Enter a password with minimum 6 characters"
            value={formData.password}
            onChange={(e) => handleInputChange(e)}
          />
                    {loader ? <Grid style={{display:'flex',flex:'1',justifyContent:'center',alignItems:'center'}}>
           <CircularProgress color="success"  />
           </Grid>:
           <Button className="button" variant="contained" onClick={login}>LOGIN TO QKART</Button>}
          <p>Do you have an account ? <span>
             <Link className="link" to="/register">Register Now</Link>
             </span>
            </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Login;
